<!-- ダイアログ:OK -->
<template>
  <modal :name="name" width="300" classes="vModal" @closed="$emit('event-dialog-closed')">
    <div class="confirmModal">
      <p>
        <span class="title">{{title}}</span>
        <span v-html="displayMessage"></span>
      </p>
      <div class="modalFooterButtons">
        <a class="modalButton" @click="$emit('event-dialog-close')">{{ buttonText }}</a>
      </div>
    </div>
  </modal>
</template>
<style>
@import "../../assets/css/modal.css";
</style>
<script>
export default {
  name: 'MessageDialog',
  props: {
    name: String,
    title: String,
    text: Array,
    buttonText: {
      type: String,
      default: 'O K',
    },
  },
  computed: {
    displayMessage() {
      return this.text.join('<br>');
    },
  },
};
</script>
